import { useQuery } from "@tanstack/react-query";
import { GeneralResponse } from "../../interface/GeneralResponse";
import Api from "../generalApi/Api";
import { Methods } from "../../Constants/ApiConstants";
import { EndPoints } from "../../Constants/endpoints";
import i18n from "../../i18n";

export interface GetTimeToResendCodeRequest {
  Id: number;
}

export interface GetTimeToResendCodeResponse extends GeneralResponse {
  Data: {
    Id: number;
    ResendCodeCount: number;
    ResendDate: string; 
  };
}

export const useGetTimeToResendCode = (id: number) => {
   
  return useQuery<GetTimeToResendCodeResponse, any>({
    queryKey: ["GetTimeToResendCode", id,i18n.language],
    queryFn: (): Promise<GetTimeToResendCodeResponse> => {
      return Api<GetTimeToResendCodeRequest, GetTimeToResendCodeResponse>({
        method: Methods.POST,
        endpoint: EndPoints.GetTimeToResendCode,
        body: { Id: id },
      });
    },
    enabled: !!id, 
  });
};
